<div class="button-select__container" [style.alignSelf]="alignSelf()">
    @for(button of buttons(); track button.value) {
        <div class="button-select__button" 
            [class.selected]="button.value === selectedButton().value" 
            (click)="selectButton(button)">
            {{button.label}}
        </div>
    }
</div>